<template>
  <div>
    <v-card class="sf-card"
            flat>
      <div class="sf-card__header">
        <h2 class="sf-card__title">{{ $t('invitation') }}</h2>
      </div>
      <v-card-text class="sf-card__body">
        <v-form ref="form">
          <h3 class="sf-section-title">{{ $t('invitationCode') }}</h3>
          <p class="sf-code">{{ supplier.invitationCode }}</p>
          <!--<v-text-field dense class="mb-4"
                        disabled
                        hide-details="auto"
                        outlined
                        v-bind:label="$t('invitationCode')"
                        v-bind:rules="[ rules.required ]"
                        v-model="supplier.invitationCode" />-->
          <v-select dense class="mb-4"
                    hide-details="auto"
                    outlined
                    v-bind:items="states"
                    v-bind:label="$t('state')"
                    v-bind:rules="[ rules.required ]"
                    v-model="supplier.state" />
          <v-checkbox color="primary"
                      class="my-0"
                      hide-details="auto"
                      v-bind:label="$t('allowCustomeOrders')"
                      v-model="supplier.allowCustomeOrders" />
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    computed: {
      rules() {
        return {
          required: v => !!v || this.$t('form.required')
        }
      },
      states() {
        return [
          {
            text: this.$t('open'),
            value: 'open'
          },
          {
            text: this.$t('invited'),
            value: 'invited'
          },
          {
            text: this.$t('accepted'),
            value: 'accepted'
          },
          {
            text: this.$t('declined'),
            value: 'declined'
          }
        ]
      }
    },
    methods: {
      validate() {
        return this.$refs.form.validate()
      }
    },
    name: 'SupplierInvitationEditCard',
    props: {
      supplier: Object
    }
  }
</script>

<style scoped>
  .sf-code {
    background: var(--sf-surface-muted);
    border: 1px solid var(--sf-border);
    border-radius: 10px;
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: .9375rem;
    letter-spacing: .04em;
    margin-bottom: 20px;
    padding: 10px 14px;
    user-select: all;
  }
</style>

<i18n>
  {
    "de": {
      "accepted": "Angenommen",
      "declined": "Abgelehnt",
      "invitation": "Einladung",
      "invitationCode": "Einladungscode",
      "invited": "Eingeladen",
      "open": "Offen",
      "state": "Status",
      "allowCustomeOrders": "Kundenindividuelle Aufstellung zulassen"
    },
    "en": {
      "accepted": "Accepted",
      "declined": "Declined",
      "invitation": "Invitation",
      "invitationCode": "Invitation code",
      "invited": "Invited",
      "open": "Open",
      "state": "State",
      "allowCustomeOrders": "Allow customer orders"
    }
  }
</i18n>